﻿export function initSite() {

    $(document).foundation();
    const newsdialog = document.getElementById("newsdialog");

    let _mtm = window._mtm = window._mtm || [];
    _mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });
    let d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true; g.src = 'https://tracking.webbanalys.msb.se/js/container_IWweAsmU.js'; s.parentNode.insertBefore(g, s);


    function menuToggle() {
        document.getElementById("menuDropdownContainer").classList.toggle("show");
    }

    $('#btnLogIn').on('click', function () {
        LogIn();
    });

    $('#btnLogOut').on('click', function () {
        LogOut();
    });

    function LogIn() {
        if ($('#txtCustomerNr').val() == '' || $('#txtCustomerKey').val() == '') {
            alert("Kundnummer och licensnyckel måste anges vid inloggning");
            return;
        }
        $.post('/Download/Login', { nr: $('#txtCustomerNr').val(), key: $('#txtCustomerKey').val() }, function (response) {
            window.location.reload();
        });
    }

    function LogOut() {
        $.ajax({
            type: 'GET',
            url: "/Download/Logout",
            dataType: 'json',
            success: function (data) {
                window.location.reload();
            }
        });

    }

    if (document.getElementById("txtCustomerNr") != null) {
        document.getElementById("txtCustomerNr").addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                LogIn();
            }
        });

        document.getElementById("txtCustomerKey").addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                LogIn();
            }
        });
    }

    // Handle changes in the color scheme
    const handleColorSchemeChange = (event) => {
        if (event.matches) {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }
    };

    // change system theme trigger this function
    // Add event listener for changes in the color scheme
    if (window.matchMedia) {
        const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches

        if (isDarkMode) {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }

        const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        darkModeMediaQuery.addEventListener('change', handleColorSchemeChange);
    } else {
        console.warn("window.matchMedia is not supported on this browser.");
    }
}